import React from "react";

const Potfolio = () => {
  return (
    <div className="w-full bg-gray-800 " id="potfolio">
      <section className="max-w-6xl mx-auto px-5 py-24 lg:max-w-full lg:px-12  ">
        <div className="text-center pb-6">
          <h1 className="font-bold text-2xl md:text-3xl lg:text-4xl font-heading text-white">
            Potfolio
          </h1>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-6  ">
          <div className="w-full bg-gray-900 rounded-lg shadow-md p-4 flex flex-col justify-center items-center transition duration-500 ease-in-out transform hover:-translate-y-1 hover:scale-110">
            <img
              className="lg:h-48 md:h-36 w-full object-cover object-center"
              src={require("../../assets/survey.png").default}
              alt="blog"
            />
            <div className="p-6">
              <h2 className="tracking-widest text-xs title-font font-medium text-gray-200 mb-1">
                SURVEY APP
              </h2>
              {/* <h1 className="title-font text-lg font-medium text-white mb-3">
                        The 400 Blows
                      </h1> */}
              <p className="leading-relaxed mb-3 text-gray-400">
                Is a semeltaneous data gathering and entry application which
                enable real time data sharing.
              </p>
              <div className="flex items-center justify-center  ">
                <a
                  className="text-red-500 inline-flex items-center md:mb-2 lg:mb-0"
                  href="https://surveyportalapp.heroku.com/"
                >
                  Learn More
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-5 w-5"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fillRule="evenodd"
                      d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z"
                      clipRule="evenodd"
                    />
                  </svg>
                </a>
              </div>
            </div>
          </div>
          <div className="w-full bg-gray-900 rounded-lg sahdow-lg p-4 flex flex-col justify-center items-center transition duration-500 ease-in-out transform hover:-translate-y-1 hover:scale-110">
            <img
              className="lg:h-48 md:h-36 w-full object-cover object-center"
              src={require("../../assets/potfolio.png").default}
              alt="blog"
            />
            <div className="p-6">
              <h2 className="tracking-widest text-xs title-font font-medium text-gray-200 mb-1">
                PERSON POTFOLIO
              </h2>
              {/* <h1 className="title-font text-lg font-medium text-white mb-3">
                        The 400 Blows
                      </h1> */}
              <p className="leading-relaxed mb-3 text-gray-400">
                It's my personal website that provide short description about my
                self and technologies I use.
              </p>
              <div className="flex items-center justify-center  ">
                <a
                  className="text-red-500 inline-flex items-center md:mb-2 lg:mb-0"
                  href="https://twitter.com/knyttneve"
                >
                  Learn More
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-5 w-5"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fillRule="evenodd"
                      d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z"
                      clipRule="evenodd"
                    />
                  </svg>
                </a>
              </div>
            </div>
          </div>
          <div className="w-full bg-gray-900 rounded-lg sahdow-lg p-4 flex flex-col justify-center items-center transition duration-500 ease-in-out transform hover:-translate-y-1 hover:scale-110">
            <img
              className="lg:h-48 md:h-36 w-full object-cover object-center"
              src={require("../../assets/hostelapp.png").default}
              alt="blog"
            />
            <div className="p-6">
              <h2 className="tracking-widest text-xs title-font font-medium text-gray-200 mb-1">
                HOSTEL SYSTEM
              </h2>
              {/* <h1 className="title-font text-lg font-medium text-white mb-3">
                        Shooting Stars
                      </h1> */}
              <p className="leading-relaxed mb-3 text-gray-400">
                This system enalbes and facilitates the management of hostel and
                students informations.
              </p>
              <div className="flex items-center justify-center  ">
                <a
                  className="text-red-500 inline-flex items-center   md:mb-2 lg:mb-0"
                  href="https://evening-atoll-10841.herokuapp.com/"
                >
                  Learn More
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-5 w-5"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fillRule="evenodd"
                      d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z"
                      clipRule="evenodd"
                    />
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Potfolio;
